import React from 'react';
import { SectionTitle } from './SectionTitle';
import { MediaSlot } from './MediaSlot';
import { CheckoutCta } from './CheckoutCta';
import { useCarousel } from '../../hooks/useCarousel';
import { printedPhotos } from '../../data/media';
export function PrintedGallery() {
  const {
    trackRef
  } = useCarousel(printedPhotos.length);
  return <section aria-labelledby="printed-title" className="overflow-hidden bg-gradient-to-b from-lavender-soft to-[#EFE4FB] py-14 md:py-20" data-id="element-224" data-mp="jmde0ub0nam1">
      <div className="px-5" data-id="element-225" data-mp="9pquc8ufepll">
        <SectionTitle id="printed-title" subtitle="Nyomtasd ki az oldalt, vegyél elő néhány színes ceruzát, és már kezdheted is. Ennyire egyszerű." data-id="element-226" data-mp="9q0ma1z176tx">
          Így néz ki kinyomtatva
        </SectionTitle>
      </div>

      <div ref={trackRef} className="no-scrollbar mx-auto mt-8 flex max-w-6xl snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-[14%] pb-4 sm:px-[25%] lg:px-8" aria-label="Kinyomtatott oldalak" data-id="element-227" data-mp="r6mk2qem0c5">
        {printedPhotos.map((src, i) => <figure key={i} className="w-[70vw] max-w-[320px] shrink-0 snap-center overflow-hidden rounded-3xl bg-white shadow-[0_12px_30px_-18px_rgba(74,58,53,0.4)]" data-id="element-228" data-mp="2rjuhsnkxo59l" data-mpi={i}>
            <MediaSlot src={src} slot={`printed-${i + 1}`} alt={`Kinyomtatott, kiszínezett oldal ${i + 1}`} aspect="aspect-[3/4]" data-id="element-229" data-mp="31afgsc4irbt1" />
          </figure>)}
      </div>

      <div className="mx-auto mt-8 max-w-xl px-5" data-id="element-230" data-mp="28nkwpgbm6eg3">
        <CheckoutCta data-id="element-231" data-mp="28oct2td1cg7f" />
      </div>
    </section>;
}